import React from "react"

export default function Header() {
    return (
        <header className="header">
            <img 
                src="./troll-face.png"
                alt="troll face"  
                className="header--image"
            />
            <h2 className="header--title">Meme Generator</h2>
        </header>
    )
}